import React from 'react';
import anchorme from 'anchorme';
import { ButtonAction, scrollElementIntoView, ShadowPosition } from 'containers/PageBuilder/SinglePageContainer/domain';
import styled from 'styled-components';
import BlockContainer from '../BlockComponents/BlockContainer';
import BlockBackgroundImage, { BlockBackgroundImageGradient } from '../BlockComponents/BlockBackgroundImage';
import BlockContentContainer from '../BlockComponents/BlockContentContainer';
import BlockTextContainer, { BlockSubTextContainer } from '../BlockComponents/BlockTextContainer';
import BlockButton from '../BlockComponents/BlockButton';
import { IBannerTextColumnBlockPreviewProps } from './IBannerTextColumnBlockPreviewProps';
import { isValidHexColor } from 'components/PageBuilder/PageBuilderSideBar/BlockSettings/domain';
import miscUtils from 'utils/miscUtils';
import { BlockButtonsContainer, BlockSideButton } from '../ButtonBlockPreview/ButtonBlockPreview';

export const BannerBlockContainer: any = styled(BlockContainer)`
    position: relative;
    min-height: 200px;
`;

export const BannerBlockBackgroundImage: any = styled(BlockBackgroundImage)`
    opacity: ${(props: any) => 
        props.design.image_opacity &&
        props.design.image_opacity <= 1 ?
        props.design.image_opacity :
        1
    };
`;

export const BannerBlockContentContainer: any = styled(BlockContentContainer)`
    z-index: 2;
    align-items: ${(props: any) => 
        props.design.text_alignment === 'center' ? 
        props.design.text_alignment :
        props.design.text_alignment === 'left' ?
        'flex-start' :
        'flex-end'
    };
    
        background-color: ${(props: any) => 
        props.design.column_container_background_color &&
        isValidHexColor(props.design.column_container_background_color) ?
        props.design.column_container_background_color :
        'transparent'
    };
    padding-top: ${(props: any) => 
        props.design.column_container_padding_top ?
        `${props.design.column_container_padding_top}px` :
        `0px`
    };
    padding-bottom: ${(props: any) => 
        props.design.column_container_padding_bottom ?
        `${props.design.column_container_padding_bottom}px` :
        `0px`
    };
    padding-left: ${(props: any) => 
        props.design.column_container_padding_left ?
        `${props.design.column_container_padding_left}px` :
        `0px`
    };
    padding-right: ${(props: any) => 
        props.design.column_container_padding_right ?
        `${props.design.column_container_padding_right}px` :
        `0px`
    };
    border-radius: ${(props: any) => 
        props.design.column_container_border_radius &&
        props.design.column_container_border_radius <= 30 ?
        `${props.design.column_container_border_radius}px`:
        `0px`
    };
    border: ${(props: any) => 
        props.design.column_container_border_color &&
        isValidHexColor(props.design.column_container_border_color) ?
        `${
            props.design.column_container_border_width ?
            props.design.column_container_border_width : 
            1
        }px solid ${props.design.column_container_border_color}` :
        `${
            props.design.column_container_border_width ?
            props.design.column_container_border_width : 
            1
        }px solid #D5D8DF`
    };
    box-shadow: ${(props: any) => 
        props.design.column_container_shadow_color &&
        isValidHexColor(props.design.column_container_shadow_color) ?
        props.design.column_container_shadow_position === ShadowPosition.Even ?
        `0px 0px 8px rgba(${miscUtils.hexToRgb(props.design.column_container_shadow_color)!.r}, ${miscUtils.hexToRgb(props.design.column_container_shadow_color)!.g}, ${miscUtils.hexToRgb(props.design.column_container_shadow_color)!.b}, ${props.design.column_container_shadow_opacity ? props.design.column_container_shadow_opacity : 0.0})` :
        props.design.column_container_shadow_position === ShadowPosition.Bottom ?
        `0px 4px 8px rgba(${miscUtils.hexToRgb(props.design.column_container_shadow_color)!.r}, ${miscUtils.hexToRgb(props.design.column_container_shadow_color)!.g}, ${miscUtils.hexToRgb(props.design.column_container_shadow_color)!.b}, ${props.design.column_container_shadow_opacity ? props.design.column_container_shadow_opacity : 0.0})` :
        props.design.column_container_shadow_position === ShadowPosition.Top ?
        `0px -4px 8px rgba(${miscUtils.hexToRgb(props.design.column_container_shadow_color)!.r}, ${miscUtils.hexToRgb(props.design.column_container_shadow_color)!.g}, ${miscUtils.hexToRgb(props.design.column_container_shadow_color)!.b}, ${props.design.column_container_shadow_opacity ? props.design.column_container_shadow_opacity : 0.0})` :
        props.design.column_container_shadow_position === ShadowPosition.BottomRight ?
        `2px 4px 8px rgba(${miscUtils.hexToRgb(props.design.column_container_shadow_color)!.r}, ${miscUtils.hexToRgb(props.design.column_container_shadow_color)!.g}, ${miscUtils.hexToRgb(props.design.column_container_shadow_color)!.b}, ${props.design.column_container_shadow_opacity ? props.design.column_container_shadow_opacity : 0.0})` :
        props.design.column_container_shadow_position === ShadowPosition.BottomLeft ?
        `-2px 4px 8px rgba(${miscUtils.hexToRgb(props.design.column_container_shadow_color)!.r}, ${miscUtils.hexToRgb(props.design.column_container_shadow_color)!.g}, ${miscUtils.hexToRgb(props.design.column_container_shadow_color)!.b}, ${props.design.column_container_shadow_opacity ? props.design.column_container_shadow_opacity : 0.0})` :
        props.design.column_container_shadow_position === ShadowPosition.TopRight ?
        `2px -4px 8px rgba(${miscUtils.hexToRgb(props.design.column_container_shadow_color)!.r}, ${miscUtils.hexToRgb(props.design.column_container_shadow_color)!.g}, ${miscUtils.hexToRgb(props.design.column_container_shadow_color)!.b}, ${props.design.column_container_shadow_opacity ? props.design.column_container_shadow_opacity : 0.0})` :
        props.design.column_container_shadow_position === ShadowPosition.TopLeft ?
        `-2px -4px 8px rgba(${miscUtils.hexToRgb(props.design.column_container_shadow_color)!.r}, ${miscUtils.hexToRgb(props.design.column_container_shadow_color)!.g}, ${miscUtils.hexToRgb(props.design.column_container_shadow_color)!.b}, ${props.design.column_container_shadow_opacity ? props.design.column_container_shadow_opacity : 0.0})` :
        'none'
        :
        'none'
    };
`;

const BannerTextColumnBlockPreview: React.FC<IBannerTextColumnBlockPreviewProps> = (props) => {

    const ctaOnClick = (blockData: any) => {
        if(props.buildingPreview) {
            return;
        }
        
        if(
            blockData &&
            (
                blockData.button_action === ButtonAction.URL ||
                blockData.button_action === ButtonAction.URLTab
            ) &&
            blockData.button_url
        ) {
            window.open(
                miscUtils.ensureHttps(blockData.button_url), 
                blockData.button_action === ButtonAction.URLTab ?
                '_blank' :
                '_self'
            );
            return;
        }

        if(
            blockData &&
            blockData.button_action === ButtonAction.Scroll &&
            blockData.button_url &&
            props.containerBaseIdName
        ) {
            scrollElementIntoView(`${props.containerBaseIdName}${blockData.button_url}`);
            return;
        }

        if(
            blockData &&
            blockData.button_action === ButtonAction.Popup &&
            blockData.button_url
        ) {
            let nextPageFormsOpenState = JSON.parse(JSON.stringify(props.pageFormsOpenState));

            nextPageFormsOpenState[blockData.button_url] = true;

            props.setPageFormsOpenState(nextPageFormsOpenState);
            return;
        }

        if(
            blockData &&
            blockData.button_action === ButtonAction.Page &&
            blockData.button_url
        ) {
            window.open(
                `${blockData.button_url}`,
                '_self'
            );
            return;
        }
    }

  return (
    <BannerBlockContainer
    design={props.blockData.design}
    >
        {props.blockData.image_url ? (
            <>
            <BannerBlockBackgroundImage
            design={props.blockData.design}
            src={props.blockData.image_url}
            alt={props.blockData.image_alt}
            />
            <BlockBackgroundImageGradient
            design={props.blockData.design}
            />
            </>
        ) : <></>}

        <BannerBlockContentContainer
        className={`${props.view ? props.view : ''}`}
        design={props.blockData.design}
        >
            <BlockTextContainer
            design={props.blockData.design}
            pageStyles={props.pageStyles}
            textKey="heading"
            fallbackTextColor="#FFFFFF"
            dangerouslySetInnerHTML={{
                __html: anchorme(props.blockData.heading),
            }}
            />


            <BlockSubTextContainer
            design={props.blockData.design}
            pageStyles={props.pageStyles}
            textKey="subtext"
            fallbackTextColor="#FFFFFF"
            dangerouslySetInnerHTML={{
                __html: anchorme(props.blockData.subtext),
            }}
            />

            {props.blockData.button_shown ? (
                <BlockButtonsContainer
                className={`${props.view ? props.view : ''}`}
                >
                    <BlockButton
                    design={props.blockData.design}
                    pageStyles={props.pageStyles}   
                    onClick={() => ctaOnClick(props.blockData)}
                    >
                        {props.blockData.button_text}
                    </BlockButton>
    
                    {props.blockData.side_by_side_buttons ? (
                        props.blockData.side_by_side_buttons.map((side_by_side_button: any, index: number) => (
                            <BlockSideButton
                            key={`${index}`}
                            className={`${props.view ? props.view : ''}`}
                            design={side_by_side_button.design}
                            pageStyles={props.pageStyles}
                            onClick={() => ctaOnClick(side_by_side_button)}
                            >
                                {side_by_side_button.button_text}
                            </BlockSideButton>
                        ))
                    ) : <></>}
                </BlockButtonsContainer>
            ) : <></>}
        </BannerBlockContentContainer>
    </BannerBlockContainer>
  )
}

export default BannerTextColumnBlockPreview;